import React from 'react'
import Hero from '../home/Hero'

import { useTranslation } from 'react-i18next'
import { useSEO } from '../../custom hooks/useSEO'
import PopularStays from '../home/PopularStays'
import Stays from './Stays'

const TripsLayout = () => {
    const { t } = useTranslation("seo");

  const seo=useSEO({
    title: t("stays.title"),
    description: t("stays.description")
  });
  return (
    <div>
      {seo}
        <Hero/>
        <PopularStays />
        <Stays/>
    </div>
  )
}

export default TripsLayout